import { createSelector } from 'reselect';
import { getRootChannel, getSubChannels } from 'utils/common';

export const navigationSelector = createSelector(
  (state) => state.navigation,
  (navigation) => navigation
);

export const navigationRootChannelsSelector = createSelector(navigationSelector, (navItems) => {
  if (navItems.length === 0) {
    return [];
  }
  const rootChannel = getRootChannel(navItems);
  return [rootChannel].concat(getSubChannels(navItems, rootChannel));
});
